import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { LangProvider } from "@/lib/i18n";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Track from "@/pages/Track";
import Admin from "@/pages/Admin";

const AuthPage = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center px-4 py-16 bg-[#050B14]">{children}</div>
);

function App() {
  return (
    <div className="App grain">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/suivi/:token" element={<Track />} />
            <Route element={<ClerkAuthProvider><Outlet /></ClerkAuthProvider>}>
              <Route path="/admin" element={<Admin />} />
              <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
              <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" />
      </LangProvider>
    </div>
  );
}

export default App;
